var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.needReconnection)?_c('ld-persistent-banner',{staticClass:"banner-ms-migration",attrs:{"warningIcon":true,"error":true,"text":_vm.text,"complete":false,"loading":true,"link":_vm.redirectUrl,"buttonText":"RECONNECT NOW"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }